import {
  useMutation,
  useQuery,
  useQueryClient,
  type UseMutationResult,
  type UseQueryResult,
} from '@tanstack/react-query';
import {
  fetchNotificationPreferences,
  updateNotificationPreferences,
} from '@/api/notificationPreferences/notificationPreferencesApi';
import type {
  NotificationPreferences,
  NotificationPreferenceUpdateItem,
} from '@/api/notificationPreferences/notificationPreferencesApi.types';
import { NOTIFICATION_PREFERENCES_QUERY_KEY } from '@/constants/queryKeys';
import { useAuth } from '@/hooks/useAuth';

export function useNotificationPreferencesQuery(): UseQueryResult<NotificationPreferences, Error> {
  const { status } = useAuth();
  return useQuery({
    queryKey: NOTIFICATION_PREFERENCES_QUERY_KEY,
    queryFn: fetchNotificationPreferences,
    enabled: status === 'authenticated',
  });
}

export function useUpdateNotificationPreferencesMutation(): UseMutationResult<
  NotificationPreferences,
  Error,
  NotificationPreferenceUpdateItem[]
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateNotificationPreferences,
    onSuccess: function storeUpdated(preferences) {
      queryClient.setQueryData(NOTIFICATION_PREFERENCES_QUERY_KEY, preferences);
    },
  });
}
